import type { DynamicPageProps } from '@/core/features/a-dynamic-page/dynamic-page-types';

import NotificationWrapper from '@/core/components/notification/notification-wrapper';
import PageComponentSwitchWrapperDesktop from '@/features/a-dynamic-page/components/page-component-switch-wrapper-desktop';
import DesktopContentWrapper from '@/features/page-layouts/desktop/desktop-content-wrapper';
import DesktopLayoutWrapper from '@/features/page-layouts/desktop/desktop-layout-wrapper';

import styles from './desktop-s2-layout.module.scss';

export default function DesktopS2Layout(props: DynamicPageProps) {
    const components = props.components;

    const headerTopComponents = components.filter((components) => components.meta.layoutPosition === 'header_top');
    const headerComponents = components.filter((component) => component.meta.layoutPosition === 'header');
    const asideComponents = components.filter((component) => component.meta.layoutPosition === 'aside');
    const mainComponents = components.filter((component) => component.meta.layoutPosition === 'main_content');
    const fullComponents = components.filter((component) => component.meta.layoutPosition === 'full');
    const footerComponents = components.filter((component) => component.meta.layoutPosition === 'footer');
    const stickyFooterComponents = components.filter((component) => component.meta.layoutPosition === 'sticky_footer');
    const hideColumnsComponents = !asideComponents.length && !mainComponents.length;

    return (
        <>
            {!!headerTopComponents.length && (
                <div className={'flex-center-vertical'}>
                    <PageComponentSwitchWrapperDesktop
                        {...props}
                        components={headerTopComponents}
                    />
                </div>
            )}
            <DesktopLayoutWrapper contentStyle={{ gap: 15 }}>
                <DesktopContentWrapper isPageLoading={props.isPageLoading}>
                    {!!headerComponents.length && (
                        <PageComponentSwitchWrapperDesktop
                            {...props}
                            components={headerComponents}
                        />
                    )}
                    {!!fullComponents.length && (
                        <div className={styles.right}>
                            <PageComponentSwitchWrapperDesktop
                                {...props}
                                components={fullComponents}
                            />
                        </div>
                    )}
                    {!hideColumnsComponents && (
                        <div className={styles.desktopS2LayoutColumnsWrapper}>
                            {!!asideComponents.length && (
                                <div className={styles.left}>
                                    <PageComponentSwitchWrapperDesktop
                                        {...props}
                                        components={asideComponents}
                                    />
                                </div>
                            )}
                            {!!mainComponents.length && (
                                <div className={styles.right}>
                                    <PageComponentSwitchWrapperDesktop
                                        {...props}
                                        components={mainComponents}
                                        divider={true}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </DesktopContentWrapper>
                <NotificationWrapper />
            </DesktopLayoutWrapper>
            {!!stickyFooterComponents.length && (
                <PageComponentSwitchWrapperDesktop
                    {...props}
                    components={stickyFooterComponents}
                />
            )}
            {!!footerComponents.length && (
                <div className={'flex-center-vertical'}>
                    <PageComponentSwitchWrapperDesktop
                        {...props}
                        components={footerComponents}
                    />
                </div>
            )}
        </>
    );
}
